// Every value the site states about the product, in one place.
//
// The pattern the app itself uses: a link that is not published yet is still
// offered and says so when it is followed, because hiding the gap hides the
// blocker.

export const APP_NAME = 'WorthLater';

/// Empty until the listing is live. The download button reads
/// "Coming to the App Store" and does nothing while it is.
export const APP_STORE_URL = '';

/// Empty until the Play listing exists.
export const PLAY_STORE_URL = '';

export const SUPPORT_EMAIL = 'cem-ergin@outlook.com';

/// Apple's standard EULA, the same terms the in-app paywall links to.
export const TERMS_URL =
  'https://www.apple.com/legal/internet-services/itunes/dev/stdeula/';

export const PRIVACY_EFFECTIVE_DATE = 'September 25, 2026';
